import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
import ElsterAssetCalculation from './ElsterAssetCalculation';
import ElsterAssetFunding from './ElsterAssetFunding';
const ElsterAssetForm = _ref => {
  var _assetInstance$asset, _assetInstance$asset2, _assetInstance$asset3, _assetInstance$asset4, _assetInstance$asset5, _assetInstance$asset6, _assetInstance$asset7, _assetInstance$asset8, _assetInstance$asset9, _assetInstance$asset0;
  let {
    assetInstance,
    closeForm,
    loading,
    change,
    submit,
    hasUnsavedChanges,
    setHasUnsavedChanges
  } = _ref;
  const {
    t
  } = useTranslation();
  const getBooleanValue = value => {
    if (value === null || value === undefined) return '';
    return value ? 'true' : 'false';
  };
  const handleBooleanChange = e => {
    const value = e.target.value === '' ? null : e.target.value === 'true';
    const syntheticEvent = {
      target: {
        name: e.target.name,
        value: value,
        type: 'select'
      }
    };
    change(syntheticEvent);
  };
  const handleDateChange = (date, fieldName) => {
    const syntheticEvent = {
      target: {
        name: fieldName,
        value: date
      }
    };
    change(syntheticEvent);
  };
  const handleCloseForm = () => {
    if (hasUnsavedChanges) {
      var _window$MARKET_CONSTA;
      const message = t((_window$MARKET_CONSTA = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA === void 0 ? void 0 : _window$MARKET_CONSTA.UNSAVED_CHANGES_MESSAGE);
      if (window.confirm(message)) {
        closeForm();
      }
    } else {
      closeForm();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, {
    className: "mx-4"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h5", {
    style: {
      height: '100px',
      display: 'flex',
      alignItems: 'center'
    }
  }, t('asset_information'), loading && /*#__PURE__*/React.createElement("span", {
    className: "ms-2",
    style: {
      height: '100px',
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    type: "spinner"
  }))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('name')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "name",
    value: (assetInstance === null || assetInstance === void 0 || (_assetInstance$asset = assetInstance.asset) === null || _assetInstance$asset === void 0 ? void 0 : _assetInstance$asset.name) || '',
    onChange: change,
    disabled: loading,
    "data-testid": "name-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    name: "is_asset_eligible_for_all_periods",
    label: t('is_asset_eligible_for_all_periods'),
    checked: (assetInstance === null || assetInstance === void 0 || (_assetInstance$asset2 = assetInstance.asset) === null || _assetInstance$asset2 === void 0 ? void 0 : _assetInstance$asset2.is_asset_eligible_for_all_periods) === true,
    onChange: change,
    disabled: loading,
    "data-testid": "is_asset_eligible_for_all_periods-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a1_type_and_description')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 5,
    style: {
      height: '150px'
    },
    name: "a1_type_and_description",
    value: (assetInstance === null || assetInstance === void 0 || (_assetInstance$asset3 = assetInstance.asset) === null || _assetInstance$asset3 === void 0 ? void 0 : _assetInstance$asset3.a1_type_and_description) || '',
    size: "md",
    type: "text",
    onChange: change,
    disabled: loading,
    "data-testid": "a1_type_and_description-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a2_asset_after_20240327')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a2_asset_after_20240327",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 || (_assetInstance$asset4 = assetInstance.asset) === null || _assetInstance$asset4 === void 0 ? void 0 : _assetInstance$asset4.a2_asset_after_20240327),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a2_asset_after_20240327-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a3_acquisition_date')), /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleDateChange(date, 'a3_acquisition_date'),
    selected: assetInstance === null || assetInstance === void 0 || (_assetInstance$asset5 = assetInstance.asset) === null || _assetInstance$asset5 === void 0 ? void 0 : _assetInstance$asset5.a3_acquisition_date,
    disabled: loading,
    "data-testid": "a3_acquisition_date-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a4_needed_for_rd')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a4_needed_for_rd",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 || (_assetInstance$asset6 = assetInstance.asset) === null || _assetInstance$asset6 === void 0 ? void 0 : _assetInstance$asset6.a4_needed_for_rd),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a4_needed_for_rd-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a5_movable')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a5_movable",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 || (_assetInstance$asset7 = assetInstance.asset) === null || _assetInstance$asset7 === void 0 ? void 0 : _assetInstance$asset7.a5_movable),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a5_movable-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no'))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a6_belongs_to_fixed_asset')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a6_belongs_to_fixed_asset",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 || (_assetInstance$asset8 = assetInstance.asset) === null || _assetInstance$asset8 === void 0 ? void 0 : _assetInstance$asset8.a6_belongs_to_fixed_asset),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a6_belongs_to_fixed_asset-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a7_internal_only')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a7_internal_only",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 || (_assetInstance$asset9 = assetInstance.asset) === null || _assetInstance$asset9 === void 0 ? void 0 : _assetInstance$asset9.a7_internal_only),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a7_internal_only-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no'))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('ayming_comment_guidance_feeling')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 5,
    style: {
      height: '150px'
    },
    name: "ayming_comment_guidance_feeling",
    value: (assetInstance === null || assetInstance === void 0 || (_assetInstance$asset0 = assetInstance.asset) === null || _assetInstance$asset0 === void 0 ? void 0 : _assetInstance$asset0.ayming_comment_guidance_feeling) || '',
    size: "md",
    type: "text",
    onChange: change,
    disabled: loading,
    "data-testid": "ayming_comment_guidance_feeling-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3 mt-4"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h5", {
    style: {
      height: '100px',
      display: 'flex',
      alignItems: 'center'
    }
  }, t('details_specific_to_period'), loading && /*#__PURE__*/React.createElement("span", {
    className: "ms-2",
    style: {
      height: '100px',
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    type: "spinner"
  }))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a8_used_for_fiscal_year_and_rd')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a8_used_for_fiscal_year_and_rd",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a8_used_for_fiscal_year_and_rd),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a8_used_for_fiscal_year_and_rd-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a9_number_of_months_not_exclusive_for_rd')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "a9_number_of_months_not_exclusive_for_rd",
    value: (assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a9_number_of_months_not_exclusive_for_rd) || '',
    onChange: change,
    disabled: loading,
    "data-testid": "a9_number_of_months_not_exclusive_for_rd-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a10_was_asset_sold_in_this_fiscal_year')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a10_was_asset_sold_in_this_fiscal_year",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a10_was_asset_sold_in_this_fiscal_year),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a10_was_asset_sold_in_this_fiscal_year-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a11_value_at_time_of_sale')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    step: "1",
    min: "0",
    value: (assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a11_value_at_time_of_sale) || '',
    name: "a11_value_at_time_of_sale",
    size: "sm",
    onChange: change,
    disabled: loading,
    "data-testid": "a11_value_at_time_of_sale-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a12_date_of_sale')), /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleDateChange(date, 'a12_date_of_sale'),
    selected: assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a12_date_of_sale,
    disabled: loading,
    "data-testid": "a12_date_of_sale-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a13_acquisition_cost')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    step: "1",
    min: "0",
    value: (assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a13_acquisition_cost) || '',
    name: "a13_acquisition_cost",
    size: "sm",
    onChange: change,
    disabled: loading,
    "data-testid": "a13_acquisition_cost-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a14_formed_under_estg')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a14_formed_under_estg",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a14_formed_under_estg),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a14_formed_under_estg-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no')))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a15_value_at_end_of_previous_fiscal_year')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    step: "1",
    min: "0",
    value: (assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a15_value_at_end_of_previous_fiscal_year) || '',
    name: "a15_value_at_end_of_previous_fiscal_year",
    size: "sm",
    onChange: change,
    disabled: loading,
    "data-testid": "a15_value_at_end_of_previous_fiscal_year-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a16_value_at_end_of_this_fiscal_year')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    step: "1",
    min: "0",
    value: (assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a16_value_at_end_of_this_fiscal_year) || '',
    name: "a16_value_at_end_of_this_fiscal_year",
    size: "sm",
    onChange: change,
    disabled: loading,
    "data-testid": "a16_value_at_end_of_this_fiscal_year-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('a17_additional_funding_applied_or_granted')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "a17_additional_funding_applied_or_granted",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.a17_additional_funding_applied_or_granted),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "a17_additional_funding_applied_or_granted-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no'))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('eligible_for_this_period')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "eligible_for_this_period",
    value: getBooleanValue(assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.eligible_for_this_period),
    onChange: handleBooleanChange,
    disabled: loading,
    "data-testid": "eligible_for_this_period-test-id"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no'))))), /*#__PURE__*/React.createElement(ElsterAssetCalculation, {
    calculationResult: assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.calculation_result,
    loading: loading
  }), (assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.id) && /*#__PURE__*/React.createElement(ElsterAssetFunding, {
    assetInstanceId: assetInstance.id,
    loading: loading,
    setParentHasUnsavedChanges: setHasUnsavedChanges
  }))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: submit,
    loading: loading,
    disabled: !hasUnsavedChanges,
    variant: "primary"
  }, t('save')), /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: handleCloseForm,
    loading: loading,
    variant: "light"
  }, t('close_form'))))));
};
export default ElsterAssetForm;